import 'assets/css/modal.css';
import 'styles/custom.css';
import * as React from 'react';
import { getRegionNames, getStats, getStatsTypeOptions } from "../components/Requests/Requests";
import Theme from '../styles/theme.js';
import {
    StandardScreen,
    StandardDropdown,
    StandardTextField,
    StandardButton,
    StatusMessage,
    StandardSearchBox,
    PageLayout
} from '../components/Layout';

class Statistics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            message: "",
            error: "",
            validationError: "",
            tableRows: "",
            tableHeaders: "",
            regionNames: "",
            type: "",
            spHostUrl: "",
            field: "",
            operator: "",
            fieldValue: "",
            regionNameChosen: "",
            typeOptions: [],
            currentPage: 1,
            pageSize: 25,
            totalCount: 0,
            totalPages: 0,
            responseType: ""
        }
    }

    componentDidMount() {
        this.initializeSettings();
    }

    initializeSettings() {
        this.getRegionNames();
        this.getTypeOptions();
    }

    async getRegionNames() {
        this.setState({ loading: true, error: "", message: "" })
        try {
            let response = await getRegionNames(this.props.accessToken);
            if (response.status === 200) {
                let data = await response.json();
                this.setState({
                    loading: false,
                    regionNames: data.map(item => ({ key: item, text: item })),
                });
            } else {
                this.setState({ loading: false, error: "Something went wrong", message: "" });
            }
        } catch (error) {
            this.setState({ loading: false, error: "Failed to load region names", message: "" });
        }
    }

    async getStats() {
        if (!this.validateForm()) return;
        this.setState({ loading: true, error: "", message: "" })
        try {
            var requestBody = {
                RegionName: this.state.regionNameChosen,
                SPHostUrl: this.state.spHostUrl,
                Type: this.state.type,
                FieldValue: this.state.fieldValue,
                Field: this.state.field,
                Operator: this.state.operator,
                PageSize: this.state.pageSize,
                PageNumber: this.state.currentPage
            };
            let response = await getStats(this.props.accessToken, requestBody);
            let results = await response.json();

            if (response.status === 200) {
                if (!results.data || results.data.length === 0) {
                    this.setState({
                        loading: false,
                        error: "There are no entries in the database matching this criteria",
                        tableRows: "",
                        tableHeaders: "",
                        totalCount: 0,
                        totalPages: 0,
                        currentPage: 1
                    });
                } else {
                    const totalCount = results.count || 0;
                    const totalPages = Math.ceil(totalCount / this.state.pageSize);
                    let tableHeaders = this.renderTableHeaders(results.type, results.data);
                    let tableRows = this.renderTableRows(results.type, results.data);
                    this.setState({
                        loading: false,
                        tableRows: tableRows,
                        tableHeaders: tableHeaders,
                        responseType: results.type,
                        totalCount: totalCount,
                        totalPages: totalPages
                    });
                }
            } else {
                this.setState({
                    loading: false,
                    error: "Something went wrong",
                    message: "",
                    totalCount: 0,
                    totalPages: 0,
                    currentPage: 1,
                    tableRows: "",
                    tableHeaders: ""
                });
            }
        } catch (error) {
            this.setState({
                loading: false,
                error: "Failed to fetch stats",
                message: "",
                totalCount: 0,
                totalPages: 0,
                currentPage: 1,
                tableRows: "",
                tableHeaders: ""
            });
        }
    }

    async getTypeOptions() {
        this.setState({ loading: true, error: "", message: "" })
        try {
            var requestBody = { RegionName: this.state.regionNameChosen };
            let response = await getStatsTypeOptions(this.props.accessToken, requestBody);
            if (response.status === 200) {
                let data = await response.json();
                const typeOptions = [
                    { key: '', text: 'Select Type' },
                    ...data.map(item => ({ key: item, text: item }))
                ];
                this.setState({
                    loading: false,
                    typeOptions: typeOptions,
                });
            } else {
                this.setState({ loading: false, error: "Something went wrong loading type options", message: "" });
            }
        } catch (error) {
            this.setState({ loading: false, error: "Failed to load type options", message: "" });
        }
    }

    onSelectRegionName = (event, item) => {
        this.setState({ regionNameChosen: item.key }, () => this.getTypeOptions());
    };

    onSelectType = (event, item) => {
        this.setState({
            type: item.key,
            field: "",
            operator: "",
            fieldValue: ""
        }, () => this.validateForm());
    };

    onSelectOperator = (event, item) => {
        this.setState({ operator: item.key }, () => this.validateForm());
    };

    onSelectField = (event, item) => {
        this.setState({ field: item.key }, () => this.validateForm());
    };

    getOperatorOptions = () => {
        const { type } = this.state;
        if (type === 'ListMetrics' ){
            return [
                { key: 'Greater Than', text: 'Greater Than' },
                { key: 'Less Than', text: 'Less Than' }
            ];
        } else if (type === 'SettingsMetrics') {
            return [
                { key: 'Equals', text: 'Equals' },
                { key: 'Greater Than', text: 'Greater Than' },
                { key: 'Less Than', text: 'Less Than' },
                { key: 'Contains', text: 'Contains' }
            ];
        } else if (type === 'HierarchyMetrics' ){
            return [
                { key: 'Greater Than', text: 'Greater Than' },
                { key: 'Less Than', text: 'Less Than' },
                { key: 'Equals', text: 'Equals' }
            ];
        } 
        return [];
    };

    getFieldOptions = () => {
        const { type } = this.state;
        if (type === 'ListMetrics') {
            return [
                { key: 'NumberOfItems', text: 'NumberOfItems' },
                { key: 'UniquePerms', text: 'UniquePermissions' }
            ];
        }
        else if (type === 'HierarchyMetrics') {
            return [
                { key: 'HierarchyCount', text: 'HierarchyCount' },
                { key: 'DeepestHierarchy', text: 'DeepestHierarchy' }
            ];
        }
        return [];
    };

    getFieldPlaceholder = () => {
        const { type } = this.state;
        if (type === 'SettingsMetrics') return "Enter field name";
        return "Select a type first";
    };

    getValuePlaceholder = () => {
        const { type, operator } = this.state;
        if ((type === 'ListMetrics' || type === 'SettingsMetrics' || type === 'HierarchyMetrics') &&
            (operator === 'Greater Than' || operator === 'Less Than')) {
            return "Enter a number";
        } else if (type === 'SettingsMetrics') {
            return "Enter a value";
        }
        return "Select an operator first";
    };

    isFilteringEnabled = () => {
        const { type } = this.state;
        return type === 'SettingsMetrics' || type === 'ListMetrics' || type === 'HierarchyMetrics';
    };

    validateForm = () => {
        let errors = [];
        const { operator, fieldValue, type } = this.state;
        if ((operator === 'Greater Than' || operator === 'Less Than') && fieldValue) {
            const isValidInt = /^\d+$/.test(fieldValue.trim());
            if ((type === 'ListMetrics' || type === 'SettingsMetrics' || type === 'HierarchyMetrics') && !isValidInt) {
                errors.push("Value must be a valid integer for Greater Than and Less Than operations");
            }
        }
        const errorMessage = errors.join(". ");
        this.setState({ validationError: errorMessage });
        return errors.length === 0;
    };

    onFieldValueChange = (event, newValue) => {
        this.setState({ fieldValue: newValue }, () => this.validateForm());
    };

    handleView = (item, index) => {
        const telemetryData = item.telemetry || '';
        let formattedData = telemetryData;
        try {
            const parsedJson = JSON.parse(telemetryData);
            formattedData = JSON.stringify(parsedJson, null, 2);
        } catch (error) {
            formattedData = telemetryData;
        }
        const newWindow = window.open('', '_blank');
        if (newWindow) {
            newWindow.document.write(`
                <html>
                    <head>
                        <title>Raw JSON Telemetry</title>
                        <style>
                            body { font-family: 'Courier New', monospace; padding: 20px; white-space: pre-wrap; word-wrap: break-word; background-color: #f5f5f5; margin: 0; line-height: 1.4; }
                        </style>
                    </head>
                    <body>
                        ${formattedData}
                    </body>
                </html>
            `);
            newWindow.document.close();
        }
    };

    handleDownload = (item, index) => {
        const telemetryData = item.telemetry || '';
        const blob = new Blob([telemetryData], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'telemetry.json';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    // Pagination methods
    handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= this.state.totalPages) {
            this.setState({ currentPage: newPage }, () => this.getStats());
        }
    };

    handlePreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.handlePageChange(this.state.currentPage - 1);
        }
    };

    handleNextPage = () => {
        if (this.state.currentPage < this.state.totalPages) {
            this.handlePageChange(this.state.currentPage + 1);
        }
    };

    renderPageNumbers = () => {
        const { currentPage, totalPages } = this.state;
        const pageNumbers = [];
        let startPage = Math.max(1, currentPage - 2);
        let endPage = Math.min(totalPages, startPage + 4);
        if (endPage - startPage < 4) {
            startPage = Math.max(1, endPage - 4);
        }
        if (startPage > 1) {
            pageNumbers.push(
                <StandardButton 
                    key={1} 
                    text="1" 
                    onClick={() => this.handlePageChange(1)}
                    disabled={1 === currentPage}
                />
            );
            if (startPage > 2) {
                pageNumbers.push(<span key="ellipsis1" style={{ margin: '0 5px' }}>...</span>);
            }
        }
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <StandardButton
                    key={i}
                    text={String(i)}
                    onClick={() => this.handlePageChange(i)}
                    disabled={i === currentPage}
                />
            );
        }
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                pageNumbers.push(<span key="ellipsis2" style={{ margin: '0 5px' }}>...</span>);
            }
            pageNumbers.push(
                <StandardButton
                    key={totalPages} 
                    text={String(totalPages)} 
                    onClick={() => this.handlePageChange(totalPages)}
                    disabled={totalPages === currentPage}
                />
            );
        }
        return pageNumbers;
    };

    renderTableHeaders(responseType, data) {
        if (!data || data.length === 0) return null;

        const thStyle = width => ({
            border: '1px solid #ddd',
            padding: '8px',
            width: `${width}%`,
            textAlign: 'center'
        });

        const headerConfig = {
            ListMetrics: [
                { label: 'Id', width: 8 },
                { label: 'SPHostUrl', width: 22 },
                { label: 'List Name', width: 20 },
                { label: 'Number of Items', width: 15 },
                { label: 'Unique Permissions', width: 17 },
                { label: 'Date of check', width: 18 }
            ],
            SettingsMetrics: [
                { label: 'Id', width: 7 },
                { label: 'SPHostUrl', width: 22 },
                { label: 'Json Path', width: 20 },
                { label: 'Field', width: 13 },
                { label: 'Value', width: 22 },
                { label: 'Date of check', width: 16 }
            ],
            TemplateMetrics: [
                { label: 'SPHostUrl', width: 22 },
                { label: 'Template Id', width: 17 },
                { label: 'Template Title', width: 21 },
                { label: 'Parent Template Id', width: 17 },
                { label: 'In Use', width: 8 },
                { label: 'Date of check', width: 15 }
            ],
            ClientCollabMetrics: [
                { label: 'SPHostUrl', width: 15 },
                { label: 'Central Portal Url', width: 15 },
                { label: 'Has Central Portal List', width: 11 },
                { label: 'Has External Hierarchy', width: 11 },
                { label: 'External Invites Enabled', width: 11 },
                { label: 'External Choice', width: 10 },
                { label: 'External Invite Link', width: 15 },
                { label: 'Date of check', width: 12 }
            ],
            HierarchyMetrics: [
                { label: 'SPHostUrl', width: 40 },
                { label: 'Hierarchy Count', width: 20 },
                { label: 'Deepest Hierarchy', width: 20 },
                { label: 'Date of check', width: 20 }
            ],
            default: [
                { label: 'SPHostUrl', width: 22 },
                { label: 'Type', width: 13 },
                { label: 'Telemetry', width: 35 },
                { label: 'Date of check', width: 15 },
                { label: 'Actions', width: 15 }
            ]
        };

        const columns = headerConfig[responseType] || headerConfig.default;

        return (
            <tr style={{ backgroundColor: '#f2f2f2' }}>
                {columns.map((col, i) => (
                    <th key={i} style={thStyle(col.width)}>{col.label}</th>
                ))}
            </tr>
        );
    }

    renderTableRows(responseType, data) {
        if (!data || data.length === 0) return null;

        switch (responseType) {
            case 'ListMetrics':
                return data.map((item, index) => (
                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff' }}>
                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.id}</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            wordBreak: 'break-word'
                        }}>{item.spHostUrl}</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            wordBreak: 'break-word'
                        }}>{item.listName}</td>
                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.numberOfItems}</td>
                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.uniquePermissions}</td>
                        <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                            {item.created ? new Date(item.created).toLocaleString(navigator.language) : ''}
                        </td>
                    </tr>
                ));
            case 'SettingsMetrics':
                return data.map((item, index) => (
                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff' }}>
                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.id}</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            wordBreak: 'break-word'
                        }}>{item.spHostUrl}</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            wordBreak: 'break-word'
                        }}>{item.jsonPath}</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            wordBreak: 'break-word'
                        }}>{item.jsonKey}</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            wordBreak: 'break-word'
                        }}>{item.jsonValue}</td>
                        <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                            {item.created ? new Date(item.created).toLocaleString(navigator.language) : ''}
                        </td>
                    </tr>
                ));
            case 'TemplateMetrics':
                return data.map((item, index) => (
                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff' }}>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            wordBreak: 'break-word'
                        }}>{item.spHostUrl}</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            wordBreak: 'break-word'
                        }}>{item.templateId}</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            wordBreak: 'break-word'
                        }}>{item.templateTitle}</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            wordBreak: 'break-word'
                        }}>{item.parentTemplateId}</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            textAlign: 'center'
                        }}>
                            <span style={{
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontSize: '12px',
                                fontWeight: 'bold',
                                backgroundColor: item.inUse ? '#d4edda' : '#f8d7da',
                                color: item.inUse ? '#155724' : '#721c24'
                            }}>
                                {item.inUse ? 'Yes' : 'No'}
                            </span>
                        </td>
                        <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                            {item.created ? new Date(item.created).toLocaleString(navigator.language) : ''}
                        </td>
                    </tr>
                ));
            case 'ClientCollabMetrics':
                return data.map((item, index) => (
                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff' }}>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            wordBreak: 'break-word'
                        }}>{item.spHostUrl}</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            wordBreak: 'break-word'
                        }}>{item.centralPortalUrl}</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            textAlign: 'center'
                        }}>
                            <span style={{
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontSize: '12px',
                                fontWeight: 'bold',
                                backgroundColor: item.hasCentralPortalListName ? '#d4edda' : '#f8d7da',
                                color: item.hasCentralPortalListName ? '#155724' : '#721c24'
                            }}>
                                {item.hasCentralPortalListName ? 'Yes' : 'No'}
                            </span>
                        </td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            textAlign: 'center'
                        }}>
                            <span style={{
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontSize: '12px',
                                fontWeight: 'bold',
                                backgroundColor: item.hasCentralPortalExternalHierarchy ? '#d4edda' : '#f8d7da',
                                color: item.hasCentralPortalExternalHierarchy ? '#155724' : '#721c24'
                            }}>
                                {item.hasCentralPortalExternalHierarchy ? 'Yes' : 'No'}
                            </span>
                        </td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            textAlign: 'center'
                        }}>
                            <span style={{
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontSize: '12px',
                                fontWeight: 'bold',
                                backgroundColor: item.hasExternalCollabInvitesEnabled ? '#d4edda' : '#f8d7da',
                                color: item.hasExternalCollabInvitesEnabled ? '#155724' : '#721c24'
                            }}>
                                {item.hasExternalCollabInvitesEnabled ? 'Yes' : 'No'}
                            </span>
                        </td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            wordBreak: 'break-word'
                        }}>{item.externalCollabChoice}</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            wordBreak: 'break-word'
                        }}>{item.externalCollabInviteLink}</td>
                        <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                            {item.created ? new Date(item.created).toLocaleString(navigator.language) : ''}
                        </td>
                    </tr>
                ));
            case 'HierarchyMetrics':
                return data.map((item, index) => (
                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff' }}>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            wordBreak: 'break-word'
                        }}>{item.spHostUrl}</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            textAlign: 'center'
                        }}>{item.hierarchyCount}</td>
                        <td style={{ 
                            border: '1px solid #ddd', 
                            padding: '8px',
                            textAlign: 'center'
                        }}>{item.deepestHierarchy}</td>
                        <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                            {item.created ? new Date(item.created).toLocaleString(navigator.language) : ''}
                        </td>
                    </tr>
                ));
            default:
                return data.map((item, index) => {
                    const telemetryText = item.telemetry || '';
                    const truncatedTelemetry = telemetryText.length > 250 
                        ? telemetryText.substring(0, 250) + '...' 
                        : telemetryText;
                    
                    return (
                        <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff' }}>
                            <td style={{ 
                                border: '1px solid #ddd', 
                                padding: '8px',
                                wordBreak: 'break-word'
                            }}>{item.spHostUrl}</td>
                            <td style={{ 
                                border: '1px solid #ddd', 
                                padding: '8px'
                            }}>{item.type}</td>
                            <td style={{ 
                                border: '1px solid #ddd', 
                                padding: '8px',
                                wordBreak: 'break-word',
                                whiteSpace: 'pre-wrap'
                            }}>{truncatedTelemetry}</td>
                            <td style={{
                                border: '1px solid #ddd',
                                padding: '8px',
                                textAlign: 'center'
                            }}>
                                {item.created ? new Date(item.created).toLocaleString(navigator.language) : ''}
                            </td>
                            <td style={{ 
                                border: '1px solid #ddd', 
                                padding: '8px',
                                textAlign: 'center'
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                    <button 
                                        style={{
                                            padding: '4px 8px',
                                            backgroundColor: '#0078d4',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '3px',
                                            cursor: 'pointer',
                                            fontSize: '12px'
                                        }}
                                        onClick={() => this.handleView(item, index)}
                                    >
                                        View
                                    </button>
                                    <button 
                                        style={{
                                            padding: '4px 8px',
                                            backgroundColor: '#107c10',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '3px',
                                            cursor: 'pointer',
                                            fontSize: '12px'
                                        }}
                                        onClick={() => this.handleDownload(item, index)}
                                    >
                                        Download
                                    </button>
                                </div>
                            </td>
                        </tr>
                    );
                });
        }
    }

    render() {
        const {
            loading, error, message, validationError, regionNameChosen, regionNames, type, typeOptions,
            spHostUrl, field, operator, fieldValue, tableRows, tableHeaders, currentPage, pageSize, totalCount, totalPages
        } = this.state;

        return (
            <PageLayout>
                <StandardScreen
                    title = "Get Statistics"
                    description={"Query the SPHostStatistics table to view stats gathered from a specific maintenance task"}
                    loading = {loading}
                >
                    <StandardDropdown
                        label = "Environment"
                        selectedKey = {regionNameChosen}
                        onChange = {this.onSelectRegionName}
                        placeholder = "Select Environment"
                        options = {regionNames}
                    >
                    </StandardDropdown>

                    <StandardSearchBox
                        label= "SPHostUrl"
                        placeholder = "SPHostUrl"
                        value = {spHostUrl}
                        onChange = {newValue => this.setState({ spHostUrl: newValue }, () => {
                            this.validateForm();
                        })}
                    >                        
                    </StandardSearchBox>

                    <StandardDropdown
                        label = "Type"
                        placeholder = "Select Type"
                        selectedKey = {type}
                        onChange = {this.onSelectType}
                        options = {typeOptions}
                    >                        
                    </StandardDropdown>

                    {type === 'ListMetrics' || type === 'HierarchyMetrics' ? (
                        <StandardDropdown
                            label = "Field"
                            placeholder = "Select Field"
                            selectedKey = {field}
                            onChange = {this.onSelectField}
                            options = {this.getFieldOptions()}
                            disabled = {!this.isFilteringEnabled()}
                        >                            
                        </StandardDropdown>
                    ):(
                        <StandardTextField
                            label = "Field"
                            placeholder = {this.getFieldPlaceholder()}
                            value = {field}
                            type = "text"
                            onChange = {(event, newValue) => this.setState({ field: newValue })}
                            disabled = {!this.isFilteringEnabled()}
                        >                            
                        </StandardTextField>
                    )}

                    <StandardDropdown
                        label = "Operator"
                        placeholder = "Select Operator"
                        selectedKey = {operator}
                        onChange = {this.onSelectOperator}
                        options = {this.getOperatorOptions()}
                        disabled = {!this.isFilteringEnabled()}                        
                    >                        
                    </StandardDropdown>

                    <StandardTextField
                        label = "Value"
                        placeholder = {this.getValuePlaceholder()}
                        value = {fieldValue}
                        type = "text"
                        onChange = {this.onFieldValueChange}
                        disabled = {!this.isFilteringEnabled()}
                    >                        
                    </StandardTextField>

                    {validationError && (
                        <StatusMessage type = "error">{validationError}</StatusMessage>
                    )}

                    <StandardButton
                        text = "Submit"
                        onClick = {() => this.getStats()}
                        disabled = {!regionNameChosen || !!validationError || loading}
                    >                        
                    </StandardButton>

                    {error && <StatusMessage type="error">{error}</StatusMessage>}
                    {message && <StatusMessage type="success">{message}</StatusMessage>}

                    <div style={{ margin: '20px' }}>
                                {this.state.loading ? (
                                    <p>Loading...</p>
                                ) : (
                                    (this.state.tableRows && this.state.tableRows.length > 0) ? (
                                        <div
                                            className="table-container"
                                            style={{
                                                marginTop: Theme.spacing.lg,
                                                marginLeft: `-${Theme.layout.contentPadding}`,
                                                marginRight: `-${Theme.layout.contentPadding}`,
                                                padding: Theme.layout.contentPadding,
                                                width: `calc(100% + ${Theme.layout.contentPadding} + ${Theme.layout.contentPadding})`,
                                                boxSizing: 'border-box'

                                            }}
                                        >
                                            {/* Pagination Info */}
                                            <div style={{ 
                                                marginBottom: '15px', 
                                                display: 'flex', 
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                backgroundColor: '#f8f9fa',
                                                padding: '10px',
                                                borderRadius: '4px',
                                                border: '1px solid #dee2e6'
                                            }}>
                                                <div style={{ fontSize: '14px', color: '#6c757d' }}>
                                                    {(() => {
                                                        const { currentPage, pageSize, totalCount, tableRows } = this.state;
                                                        if (!tableRows || totalCount === 0) {
                                                            return 'Showing 0 to 0 of 0 records';
                                                        }
                                                        const start = ((currentPage - 1) * pageSize) + 1;
                                                        const end = Math.min(currentPage * pageSize, totalCount);
                                                        const validStart = Math.min(start, end, totalCount);
                                                        const validEnd = Math.max(validStart, end);
                                                        return `Showing ${validStart} to ${validEnd} of ${totalCount} records`;
                                                    })()}
                                                </div>
                                                <div style={{ fontSize: '14px', color: '#6c757d' }}>
                                                    Page {this.state.currentPage} of {this.state.totalPages}
                                                </div>
                                            </div>
                                            
                                            {/* Table */}
                                            <div style={{ overflowX: 'auto', width: '100%' }}>
                                                <table style={{ 
                                                    width: '100%', 
                                                    borderCollapse: 'collapse', 
                                                    marginBottom: '20px',
                                                    tableLayout: 'auto'
                                                }}>
                                                    <thead>
                                                        {this.state.tableHeaders}
                                                    </thead>
                                                    <tbody>
                                                        {this.state.tableRows}
                                                    </tbody>
                                                </table>
                                            </div>
                                            
                                            {/* Pagination Controls */}
                                            {this.state.totalPages > 1 && (
                                                <div style={{ 
                                                    display: 'flex', 
                                                    justifyContent: 'center', 
                                                    alignItems: 'center',
                                                    gap: '10px',
                                                    marginTop: '20px',
                                                    padding: '15px',
                                                    backgroundColor: '#f8f9fa',
                                                    borderRadius: '4px',
                                                    border: '1px solid #dee2e6'
                                                }}>
                                                    <StandardButton
                                                        text = "Previous"
                                                        disabled = {this.state.currentPage === 1}
                                                        onClick = {this.handlePreviousPage}
                                                    >
                                                    </StandardButton>
                                                    
                                                    <div style={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center', 
                                                        gap: '5px',
                                                        margin: '0 15px'
                                                    }}>
                                                        {/* Show page numbers */}
                                                        {this.renderPageNumbers()}
                                                    </div>

                                                    <StandardButton
                                                        text = "Next"
                                                        disabled = {this.state.currentPage === this.state.totalPages}
                                                        onClick = {this.handleNextPage}
                                                    >
                                                    </StandardButton>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <p></p>
                                    )
                                )}
                            </div> 
                </StandardScreen>
            </PageLayout>);
    }
}

export default Statistics;